export default __webpack_public_path__ + "static/media/plus-time.16d1cf30.svg";